import router from './router'
import store from './store'
import {Toast} from 'vant';
import cookie from '@assets/js/public/Cookie'
import httpUtils from '@/utils/http-utils'
import {memberApi} from "@/api/member";
import Base64 from "./utils/base64";
import {Source} from '@/utils/source'
import Bridge from '@/utils/bridge'
import {getToken} from "@/utils/auth";

router.beforeEach((to, from, next) => {
  if ((to.path === '/login' || to.path === '/sign-up/login') && store.state.loginStatus) {
    next(from)
  }
  let source = Source.getSource()
  if (to.matched.some(record => record.meta.requiresLogin)) {
    if (!store.state.loginStatus) {
      if (source === 'ANDROID') {
        window.android.login()
      } else if (source === 'IOS') {
        Bridge.callhandler('showMessage', "请先登录<br/>首次关注公安服务平台请先<span style=\"font-weight: bolder;color: #0D0D0D  \">注册</span>")
        Bridge.callhandler('goNewVC', {"newPath": '', "newVC": "LoginVC"}, (data) => {
        });
      } else if (source === 'ALIPAY') {
        cookie.removeUser();
        next({
          path: '/login',
          query: {returnUrl: encodeURIComponent(to.fullPath)}
        })
      } else {
        cookie.removeUser();
        next({
          path: '/login',
          query: {returnUrl: encodeURIComponent(to.fullPath)}
        })
      }
    } else {
      next();
    }
  } else {
    next(); // 确保一定要调用 next()
  }
});
router.beforeEach(async (to, from, next) => {
  let source = Source.getSource()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //获取登陆状态
    if (!store.state.loginStatus) {
      if (source === 'ANDROID') {
        window.android.login()
      } else if (source === 'IOS') {
        Bridge.callhandler('showMessage', "请先登录<br/>首次关注公安服务平台请先<span style=\"font-weight: bolder;color: #0D0D0D  \">注册</span>")
        Bridge.callhandler('goNewVC', {"newPath": '', "newVC": "LoginVC"}, (data) => {
        });
      } else if (source === 'ALIPAY') {
        cookie.removeUser();
        next({
          path: '/login',
          query: {returnUrl: encodeURIComponent(to.fullPath)}
        })
      } else {
        cookie.removeUser();
        next({
          path: '/login',
          query: {returnUrl: encodeURIComponent(to.fullPath)}
        })
      }
    } else {
      //获取用户信息
      let data = {name: "", idCard: ""};
      let UserInfo = new Promise(resolve => {
        httpUtils.getGatewayUtils(`${memberApi.getUserInfo}` + `?t=${new Date().getTime()}`).then(res => {
          if (res.data.succ) {
            cookie.setUser(res.data.data)
            data = {
              name: res.data.data.realName,
              idCard: res.data.data.idNum
            }
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
      let flag = await UserInfo
      if (flag) {
        httpUtils.postJson(memberApi.userinfocheck, data).then((res) => {
          if (res.data.succ) {
            let loginUserInfo = cookie.getUser()
            if (loginUserInfo.realStatus && loginUserInfo.realStatus === '1') {
              next();
            } else {
              if (source === 'ANDROID') {
                window.android.auth()
              } else if (source === 'IOS') {
                Bridge.callhandler('showMessage', "请先认证");
                Bridge.callhandler('goNewVC', {"newPath": "", "newVC": "AuthenticationVC"}, (data) => {
                });
              } else if (source === 'ALIPAY') {
                const token = getToken('access_token')
                window.location.href = `${global.realAuthenticationUrl}?token=${token}`
              } else {
                //实人跳转
                const token = getToken('access_token')
                window.location.href = `${global.realAuthenticationUrl}?token=${token}`
                // const redirect = encodeURIComponent(global.weixinbaseUrl + '/#' + to.fullPath);
                // window.location.href = global.realAuthenticationUrl + '/service-auth?info=' + encodeURIComponent(Base64.encode(JSON.stringify(data))) + '&redirect=' + redirect;
              }
            }
          } else {
            Toast.fail("该用户未注册,或身份证号与姓名不匹配")
            if (source === 'ANDROID') {
              window.android.goHome()
            } else if (source === 'IOS') {
              Bridge.callhandler('showMessage', "该用户未注册,或身份证号与姓名不匹配");
            } else if (source === 'ALIPAY') {
              next({
                path: '/',
              });
            } else {
              next({
                path: '/',
              });
            }
          }
        }).catch((error) => {
          Toast.fail('服务器运行失败，请稍后再试。')
          next({
            path: '/',
          });
        });
      } else {
        Toast.fail('服务器运行失败，请稍后再试。')
        next({
          path: '/',
        });
      }
    }
  } else {
    next()
  }
})


router.beforeEach(async (to, from, next) => {
  let source = Source.getSource()
  if (to.path === '/advisoryList') {
    if (source === 'IOS') {
      if (to.matched.some(record => record.components.floor)) {
        console.log('ios去除底部')
        for (let i = 0; i < to.matched.length; i++) {
          const obj = to.matched[i].components
          console.log(obj)
          delete obj.floor
        }
        next()
      } else {
        next()
      }
    } else {
      next()
    }


  } else {
    next()
  }
})


router.afterEach((ro_route, from_route) => {
  cookie.refreshCookie(window.global.cookieName);
  // cookie.refreshCookie("access_token");
  // cookie.refreshCookie("refresh_token");
});
//解决页面偶尔进入不了问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})

